// Champion JSON owns release limits and the level unlocked at each story stage.
export function contentLimits(model, premium) {
  return { ...model.progression.limits[premium ? 'premium' : 'public'] };
}

export function unlockedLevel(model, progress, premium) {
  const limits = contentLimits(model, premium);
  const levels = model.progression.levelUnlocks;
  const stage = Math.max(0, Math.min(progress, limits.storyProgress, levels.length) - 1);
  return Math.min(levels[stage], limits.level);
}

export function devotionLimit(limits, devotion) {
  return devotion === 'maze' ? limits.mazePower : devotion === 'cards' ? limits.cardRank : Infinity;
}

export function storySceneLevels(model) {
  return Object.entries(model.progression.storySceneLevels).sort((a, b) => a[1] - b[1]);
}
